import { useQuery, useQueryClient } from '@tanstack/react-query'
import { ReactNode, useMemo } from 'react'
import apiClient from '../services/apiClient'
import { UserContextType } from '../types/user.type'
import UserContext from './UserContext'

interface UserContextProviderProps {
    children: ReactNode
}

function UserContextProvider({ children }: UserContextProviderProps) {
    const { data, isLoading, error } = useQuery({
        queryKey: ['auth-check'],
        queryFn: () => apiClient.get('/users/check-auth').then((res) => res.data),
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 24 * 60 * 60 * 1000, // 1 jour
    })

    const user: UserContextType = useMemo(
        () => ({
            tokenAdmin: '', // Plus utilisé, conservé pour compatibilité
            adminData: data?.adminData || undefined,
            tokenMember: '', // Plus utilisé, conservé pour compatibilité
            memberData: data?.memberData || undefined,
            tokenCoach: '', // Plus utilisé, conservé pour compatibilité
            coachData: data?.coachData || undefined,
            activeRole: data?.activeRole || null,
        }),
        [data],
    )

    // Fonction pour rafraîchir les données utilisateur (utile après login)
    const queryClientInstance = useQueryClient()
    const refreshUserData = () => {
        queryClientInstance.invalidateQueries({ queryKey: ['auth-check'] })
    }

    // Exposer la fonction de rafraîchissement dans le contexte
    const contextValue = useMemo(
        () => ({
            ...user,
            refreshUserData,
        }),
        [user],
    )

    return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
}

export default UserContextProvider
